import React, { PureComponent } from 'react';
import {
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonImg,
  IonCardTitle,
  IonSkeletonText
} from '@ionic/react';
import Post from '../models/Post';

interface Props {
  post?: Post;
}

export default class NewsCard extends PureComponent<Props> {
  formattedDate() {
    return this.props.post?.created_at.toLocaleDateString('fr-FR');
  }

  render() {
    if (!this.props.post) {
      return (
        <IonCard>
          <IonCardHeader>
            <IonCardSubtitle>
              <IonSkeletonText animated style={{ width: '20%' }} />
            </IonCardSubtitle>
            <IonCardTitle>
              <IonSkeletonText animated style={{ width: '88%' }} />
              <IonSkeletonText animated style={{ width: '70%' }} />
              <IonSkeletonText animated style={{ width: '60%' }} />
            </IonCardTitle>
          </IonCardHeader>
        </IonCard>
      );
    }

    return (
      <IonCard routerLink={`/dashboard/actualites/${this.props.post.id}`}>
        <IonCardHeader>
          <IonCardSubtitle>{this.formattedDate()}</IonCardSubtitle>
          <IonCardTitle>{this.props.post.title}</IonCardTitle>
        </IonCardHeader>

        {this.props.post.thumbnail ? (
          <IonImg src={this.props.post.thumbnail} />
        ) : null}
      </IonCard>
    );
  }
}
